import React, { useState } from 'react';

import classNames from 'classnames';

import { useIsSmallScreen } from '@client/dev/components/utils/useIsSmallScreen';

export const DevPanelContainer = ({ isOpen, children }) => {
  const isSmallScreen = useIsSmallScreen();
  const [animate, setAnimate] = useState(true);

  const handleMouseDown = () => {
    setAnimate(false); // Disable animation on resize
  };
  const onMouseUp = () => {
    setAnimate(true); // Disable animation on resize
  };

  return (
    <div
      className={classNames(
        'fixed top-0 left-0 flex flex-col p-2 gap-8 z-30 overflow-auto max-h-screen min-h-28 min-w-96 p-0',
        {}
      )}
      style={{
        resize: isOpen ? 'both' : 'none',
        overflowY: isOpen ? 'scroll' : 'hidden',
        overflowX: isOpen ? 'auto' : 'hidden',
        background: '#FFFFFF',
        // borderBottom: '1px solid gray',
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.3)',

        // background: '#24292f',

        // Only apply transition when `animate` is true
        transition: animate ? 'width 500ms ease, height 500ms ease' : 'none',

        // Set starting width and height if open
        width: isOpen ? (isSmallScreen ? '80%' : '425px') : 90,
        height: isOpen ? (isSmallScreen ? '100%' : '800px') : 30,

        // Set max limits if needed for larger screens
        maxWidth: isSmallScreen ? '90vw' : '100vw',
        maxHeight: isSmallScreen ? '100vh' : '100vh',
        overscrollBehavior: 'contain'
      }}
      onMouseDown={handleMouseDown} // Disable animation on resize
      onMouseUp={onMouseUp} // Disable animation on resize
    >
      {children}
    </div>
  );
};
